import FieldModel      from '@models/map/FieldModel';
import PlaceTypeModel  from '@models/map/PlaceTypeModel';
import doc             from '@widesk-core/decorators/doc';
import model           from '@widesk-core/decorators/model';
import MapServiceModel from '@/models/MapServiceModel';
import TimestampAble   from '@widesk-core/models/traits/TimestampAble';
import Blamable        from '@/models/traits/Blamable';

@model.urnResource('place_type_field')
@doc.path('/place_type_fields/{?id}')
export default class PlaceTypeFieldModel extends Blamable(TimestampAble(MapServiceModel)) {
	private declare _tsFilters: {
		'createdAt': string;
		'field': id;
		'placeType': id;
		'updatedAt': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'position': string;
		'updatedAt': string;
	};	

	@doc.model(FieldModel) declare field: FieldModel;
	@doc.model(PlaceTypeModel) declare placeType: PlaceTypeModel;
	@doc.number declare position: number;
}